import { render, staticRenderFns } from "./VTable.vue?vue&type=template&id=24778443&scoped=true&"
import script from "./VTable.vue?vue&type=script&lang=js&"
export * from "./VTable.vue?vue&type=script&lang=js&"
import style0 from "./VTable.vue?vue&type=style&index=0&id=24778443&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24778443",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24778443')) {
      api.createRecord('24778443', component.options)
    } else {
      api.reload('24778443', component.options)
    }
    module.hot.accept("./VTable.vue?vue&type=template&id=24778443&scoped=true&", function () {
      api.rerender('24778443', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/addresses/components/VTable.vue"
export default component.exports